<script setup lang="ts">
interface SceneClipOption {
  value: string
  label: string
  detail: string
}

withDefaults(
  defineProps<{
    title?: string
    subtitle?: string
    badge: string
    description?: string
    selectionOptions: SceneClipOption[]
    selectionValue: string
    applyOptions: SceneClipOption[]
    applyValue: string
    active: boolean
    liveBox: boolean
    canConfirm?: boolean
    clearDisabled?: boolean
    confirmLabel?: string
    clearLabel?: string
  }>(),
  {
    title: '裁切工具',
    subtitle: '选择方式、内外裁与确认裁切',
    description: '',
    canConfirm: false,
    clearDisabled: false,
    confirmLabel: '确认裁切',
    clearLabel: '清空已确认裁切',
  },
)

const emit = defineEmits<{
  (event: 'select-selection', value: string): void
  (event: 'select-apply', value: string): void
  (event: 'confirm'): void
  (event: 'clear'): void
}>()
</script>

<template>
  <details class="panel-subsection clip-card" open>
    <summary class="panel-subsection-summary">
      <span class="summary-main">
        <span class="panel-subsection-title">{{ title }}</span>
        <span class="panel-section-subtitle">{{ subtitle }}</span>
      </span>
      <span class="summary-side">
        <span class="card-badge">{{ badge }}</span>
        <span class="summary-chevron" aria-hidden="true">›</span>
      </span>
    </summary>

    <div class="panel-subsection-body">
      <p v-if="description" class="card-description">{{ description }}</p>

      <div class="button-grid button-grid-three clip-selection-grid">
        <button
          v-for="item in selectionOptions"
          :key="item.value"
          class="panel-button"
          :class="{ active: active && selectionValue === item.value }"
          @click="emit('select-selection', item.value)"
        >
          <span class="panel-button-label">{{ item.label }}</span>
          <span class="panel-button-meta">{{ item.detail }}</span>
        </button>
      </div>

      <div v-if="!liveBox" class="button-grid button-grid-two clip-apply-grid">
        <button
          v-for="item in applyOptions"
          :key="item.value"
          class="panel-button"
          :class="{ active: active && applyValue === item.value }"
          @click="emit('select-apply', item.value)"
        >
          <span class="panel-button-label">{{ item.label }}</span>
          <span class="panel-button-meta">{{ item.detail }}</span>
        </button>
      </div>

      <button
        v-if="!liveBox"
        class="panel-button panel-button-wide clip-confirm"
        :class="{ active: canConfirm }"
        :disabled="!canConfirm"
        @click="emit('confirm')"
      >
        {{ confirmLabel }}
      </button>

      <button
        v-if="!liveBox"
        class="panel-button panel-button-wide panel-button-subtle clip-clear"
        :disabled="clearDisabled"
        @click="emit('clear')"
      >
        {{ clearLabel }}
      </button>
    </div>
  </details>
</template>

<style scoped>
.card-description,
.clip-selection-grid,
.clip-apply-grid,
.clip-confirm,
.clip-clear {
  margin-top: 12px;
}

.card-description {
  font-size: 13px;
  line-height: 1.5;
  color: #c7d8e4;
}

.clip-card .panel-button.active {
  border-color: rgba(255, 183, 77, 0.72);
  background: linear-gradient(180deg, rgba(121, 72, 18, 0.94) 0%, rgba(73, 39, 9, 0.94) 100%);
  box-shadow: inset 0 0 0 1px rgba(255, 212, 128, 0.16);
}
</style>
